import Navbar from "../components/Navbar";
import PixelCanvas from "../components/PixelCanvas";
import EditHistory from "../components/EditHistory";
import Information from "../components/Information";
//import Maintenance from "../components/Maintenance";
import TopContributors from "../components/TopContributors";

const HomePage = () => {
  return (
    <div className="rt">
      <Navbar />
      <PixelCanvas />
      <br />
      <hr />
      <TopContributors preview="true" />
      <hr />
      <EditHistory preview="true" />
      <Information />
    </div>
  );
};

export default HomePage;
